import { Injectable } from '@angular/core';
import { EventsCore } from '../shared/events';
import { ERROR_PRIORITY, ERROR_TYPE } from '../shared/enum';
import { HttpRequest } from '@angular/common/http';
import { IGlobalError } from '../shared/types';
import { getUID } from '../../shared/uuid/uuid.generator';
import { Observable } from 'rxjs';

const DEBUG_MODE = false;
const DEFAULT_MESSAGE = 'Unhandled API Error occurred';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService {
  public readonly events$: EventsCore<ERROR_PRIORITY> = new EventsCore<ERROR_PRIORITY>();

  public readonly DEBUG_MODE: boolean = DEBUG_MODE;

  public handleError = (
    data: any,
    origin: HttpRequest<any> | any,
    type: ERROR_TYPE,
    priority: ERROR_PRIORITY = ERROR_PRIORITY.WARNING
  ): this => {
    const { events$ } = this;

    if (type === ERROR_TYPE.API_ERROR) {
      const { status, statusText } = data;
      const message = data.error?.message || data.message || DEFAULT_MESSAGE;
      const timestamp = new Date().getTime();

      events$.emitEvent(priority, {
        id: getUID(),
        priority,
        type,
        message,
        status,
        statusText,
        origin,
        timestamp,
      } as IGlobalError);
    }

    return this;
  };

  public onError = (priority: ERROR_PRIORITY): Observable<IGlobalError> => {
    return this.events$.onEvent(priority);
  };

  public emitFakeError = (): void => {
    const { WARNING, MODERATE, CRITICAL } = ERROR_PRIORITY;
    const priority = [WARNING, MODERATE, CRITICAL][Math.floor(Math.random() * 3)];
    const url = 'http://sync.local.wmg.com:4200/api/some-fake-url';
    const errMessage =
      priority === WARNING
        ? "Something went wrong, but don't worry about it"
        : priority === MODERATE
        ? 'Something went wrong'
        : 'Something went wrong COMPLETELY! AAAAA! We all are going to DIE!!!!!';

    this.handleError(
      {
        headers: {
          normalizedNames: {},
          lazyUpdate: null,
        },
        status: 500,
        statusText: errMessage,
        url,
        ok: false,
        name: 'HttpErrorResponse',
        message: '',
        error: {
          status: 'error',
          message: errMessage,
        },
      },
      {
        url,
        method: 'POST',
        headers: {},
        params: {},
        urlWithParams: url,
      },
      ERROR_TYPE.API_ERROR,
      priority
    );
  };
}
